import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';

import { AuthService } from '../_service/auth.service';
import { CompanyService } from '../_service/company.service';
import { TenantService } from '../_service/tenant.service';
import { EquipmentService } from '../_service/equipment.service';
import * as routing from '../_model/routing'
import { VesselService } from '../_service/vessel.service';
import { UserService } from '../_service/user.service';
import { OpenWebUIService } from '../_service/open-web-ui.service';
import { async, Subject, takeUntil, forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { getCompanyData } from '../_model/company';
import { StreamingHttpUtil } from '../_common/common.streaminghttp';
import { getVesselData } from '../_model/vessel';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { RoutingService } from '../_service/routing.service';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { ClaimService } from '../_service/claim.service';
import { STATUS } from '../_model/string_literal';
import { ClaimNewComponent } from './claim-center/claim-new/claim-new.component';
import { ChartConfiguration, ChartData } from 'chart.js';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {

  private onDestroy$ = new Subject();
  private refreshTimer: number | null = null;
  isBlocked = false;
  mode = "day";
  constructor(
    public router: Router,
    private check: RoutingService,
    private auth: AuthService,
    private companyService: CompanyService,
    private vesselService: VesselService,
    private tenantService: TenantService,
    private userService: UserService,
    private route: ActivatedRoute,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private authService: MsalService,
    private equipmentService: EquipmentService,
    private openWebUIService: OpenWebUIService,
    private claimService: ClaimService,
    private dialog: MatDialog,
  ) { this.isBlocked = this.check.isBlocked;
    
    this.iconRegistry.addSvgIcon(
      'plus',
      sanitizer.bypassSecurityTrustResourceUrl('assets/plus.svg')
    );
  }

  companyCounter = 0;
  vesselCounter = 0;
  userCounter = 0;
  initCompanyListFlag = false;
  initVesselListFlag = false;
  initTenantListFlag = false;
  isCompanyPage = false;
  isVesselPage = false;
  selectedTab: string = 'tab1';
  inkBarPosition: string = '0%';
  claimSummary = {
    New: 0,
    Open: 0,
    Resolved: 0,
    Closed: 0,
  };
  totalClaims = 0;
  overallClaimSummary = {
    New: 0,
    Open: 0,
    Resolved: 0,
    Closed: 0,
  };
  overallTotalClaims = 0;
  claimChartData: ChartData<'doughnut'> = {
    labels: ['New', 'Open', 'Resolved', 'Closed'],
    datasets: [{ data: [0, 0, 0, 0], backgroundColor: ['#1976d2', '#f57c00', '#388e3c', '#616161'], borderColor: 'transparent' }],
  };
  overallChartData: ChartData<'doughnut'> = {
    labels: ['New', 'Open', 'Resolved', 'Closed'],
    datasets: [{ data: [0, 0, 0, 0], backgroundColor: ['#1976d2', '#f57c00', '#388e3c', '#616161'], borderColor: 'transparent' }],
  };
  chartConfig: ChartConfiguration<'doughnut'>['options'] = {
    cutout: '72%',
    radius: '100%',
    plugins: { legend: { display: false } },
  };

  ngOnInit(): void {
    this.initAllList();
    this.getIsCompanyPage();
    this.refreshDashboardData();
    this.auth.authReady$.pipe(takeUntil(this.onDestroy$)).subscribe((isReady) => {
      if (isReady) {
        this.refreshDashboardData();
      }
    });
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
    });

    this.refreshTimer = window.setInterval(() => {
      this.refreshDashboardData();
    }, 10 * 60 * 1000);
  }

  ngOnDestroy(): void {
    if (this.refreshTimer) {
      window.clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
    this.onDestroy$.next(1);
    this.onDestroy$.complete();
  }

  private refreshDashboardData(): void {
    this.loadOverallClaimSummary();
    if (this.auth?.userId || this.auth?.userName || this.auth?.email) {
      this.loadClaimSummary();
    }
  }

  getAllCount() {
    this.getCompanyCount();
    this.getVesselCount();
    this.getUserCount();
  }

  initAllList() {
    this.initCompanyList();
    this.initVesselList();
    this.initTenantList();
    this.initUserList();
    this.initEquipList();
    this.initOWUUserList();
  }

  initOWUUserList() {
    this.getOWUUserList();
  }

  getOWUUserList() {
    this.openWebUIService.getOWUUserList(1).subscribe({
      next: (value: any) => {
        const total = value.total;
        const pageSize = value.users.length;
        const totalPages = Math.ceil(total / pageSize);
        let allUsers = [...value.users];
        if (totalPages > 1) {
          const requests = [];
          for (let p = 2; p <= totalPages; p++) {
            requests.push(this.openWebUIService.getOWUUserList(p));
          }

          forkJoin(requests).subscribe({
            next: (responses: any[]) => {
              responses.forEach(r => allUsers = [...allUsers, ...r.users]);
              this.openWebUIService.userNo = total;
              this.openWebUIService.userList = allUsers;
            }
          });
        } else {
          this.openWebUIService.userNo = total;
          this.openWebUIService.userList = allUsers;
        }
      }
    })
  }

  initEquipList() {
    this.equipmentService.equipList = [];
    this.equipmentService.manufacturerList = [];
    this.equipmentService.getAllEquip()
      .subscribe({
        next: (value: any) => {
          this.equipmentService.equipList = value?.data;
        },
    });

    this.equipmentService.getAllManufacturer()
      .subscribe({
        next: (value: any) => {
          this.equipmentService.manufacturerList = value?.data;
        },
    });
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
    if (tab === 'tab1') {
      this.inkBarPosition = '0%';
      // this.router.navigate([routing.AllEntries]);
    } else{
      this.inkBarPosition = '100%';
    }
  }
  getCompanyCount() {
    this.companyService.getCompanyCount()
    .subscribe({
      next: (value) => {this.companyCounter = value.count;}
    })
  }

  getVesselCount() {
    this.vesselService.getVesselCount()
    .subscribe({
      next: (value) => {this.vesselCounter = value.count}
    })
  }

  initVesselList() {
    this.vesselService.vesselList = [];
    this.vesselService.getVesselList()
    .subscribe({
      next: async(value) => {
        const streamingJson = await StreamingHttpUtil.getStream(value);
        const vessels:getVesselData[] = JSON.parse(streamingJson);
        this.vesselService.vesselList.push(...vessels);
        this.vesselService.setVesselList(this.vesselService.vesselList);
      },
      complete: () => {
        this.initVesselListFlag = true;
      }
    });
  }

  initUserList() {
    this.userService.getUserList()
    .subscribe({
      next: (value) => {
        this.userService.userList.push(...value);
        this.userService.setUserList(value);
        if (this.auth?.userId || this.auth?.userName) {
          this.loadClaimSummary();
        }
      },
    })
  }

  initCompanyList() {
    this.companyService.companyList = [];
    this.companyService.getCompanyList()
    .subscribe({
      next: async(value:any) => {
        const streamingJson = await StreamingHttpUtil.getStream(value);
        const companies:getCompanyData[] = JSON.parse(streamingJson);
        this.companyService.companyList.push(...companies);
        this.companyService.setCompanyList(this.companyService.companyList);
      },
      complete: () => {
        this.initCompanyListFlag = true;
      }
    })
  }

  initTenantList() {
    this.tenantService.getTenantList()
      .subscribe({
        next: async(value: any) => {
          this.tenantService.tenantList = value;
        },
        complete: () => {
          this.initTenantListFlag = true;
        }
      });
  }

  getUserCount() {
    this.userService.getUserCount()
    .subscribe({
      next: (value) => {this.userCounter = value.count}
    })
  }

  loadClaimSummary() {
    const candidates = this.getClaimLookupCandidates();

    if (!candidates.length) {
      this.claimSummary = { New: 0, Open: 0, Resolved: 0, Closed: 0 };
      this.totalClaims = 0;
      this.updateChartData();
      return;
    }

    this.loadClaimSummaryForCandidates(candidates, 0);
  }

  private getClaimLookupCandidates(): string[] {
    const candidates = new Set<string>();

    if (this.auth?.userId) {
      candidates.add(this.auth.userId);
    }

    return Array.from(candidates).filter(Boolean);
  }

  private loadClaimSummaryForCandidates(candidates: string[], index: number) {
    const currentCandidate = candidates[index];

    if (!currentCandidate) {
      this.claimSummary = { New: 0, Open: 0, Resolved: 0, Closed: 0 };
      this.totalClaims = 0;
      this.updateChartData();
      return;
    }

    this.claimService.getClaimsByAssigneeId(currentCandidate).subscribe({
      next: (value: any) => {
        const claims = this.normalizeClaims(value);

        if (claims.length > 0 || index >= candidates.length - 1) {
          this.applyClaimSummary(claims);
          return;
        }

        this.loadClaimSummaryForCandidates(candidates, index + 1);
      },
      error: () => {
        if (index >= candidates.length - 1) {
          this.claimSummary = { New: 0, Open: 0, Resolved: 0, Closed: 0 };
          this.totalClaims = 0;
          this.updateChartData();
          return;
        }

        this.loadClaimSummaryForCandidates(candidates, index + 1);
      }
    });
  }

  private normalizeClaims(value: any): any[] {
    return Array.isArray(value)
      ? value
      : Array.isArray(value?.data)
        ? value.data
        : Array.isArray(value?.items)
          ? value.items
          : Array.isArray(value?.claims)
            ? value.claims
            : [];
  }

  private applyClaimSummary(claims: any[]) {
    this.claimSummary = claims.reduce((summary: any, claim: any) => {
      if (claim?.status === STATUS.RESOLVED) {
        summary.Resolved += 1;
      } else if (claim?.status === STATUS.CLOSED) {
        summary.Closed += 1;
      } else if (claim?.status === STATUS.NEW) {
        if (claim?.assignee === null || claim?.assignee === undefined) {
          summary.New += 1;
        } else {
          summary.Open += 1;
        }
      } else {
        summary.Open += 1;
      }
      return summary;
    }, { New: 0, Open: 0, Resolved: 0, Closed: 0 });

    this.totalClaims = Object.values(this.claimSummary).reduce((sum: number, count: any) => sum + Number(count || 0), 0);
    this.updateChartData();
  }

  loadOverallClaimSummary() {
    this.claimService.getClaimStats().subscribe({
      next: (value: any) => {
        this.overallClaimSummary = this.normalizeClaimSummary(value);
        this.overallTotalClaims = Object.values(this.overallClaimSummary).reduce((sum: number, count: any) => sum + Number(count || 0), 0);
        this.updateChartData();
      },
      error: () => {
        this.overallClaimSummary = { New: 0, Open: 0, Resolved: 0, Closed: 0 };
        this.overallTotalClaims = 0;
        this.updateChartData();
      }
    });
  }

  private normalizeClaimSummary(value: any) {
    const summary = { New: 0, Open: 0, Resolved: 0, Closed: 0 };

    if (!value || typeof value !== 'object') {
      return summary;
    }

    const getValue = (keys: string[]) => {
      for (const key of keys) {
        if (value[key] !== undefined && value[key] !== null) {
          return Number(value[key]) || 0;
        }
      }
      return 0;
    };

    summary.New = getValue(['New', 'new']);
    summary.Open = getValue(['Open', 'open']);
    summary.Resolved = getValue(['Resolved', 'resolved']);
    summary.Closed = getValue(['Closed', 'closed']);

    return summary;
  }

  private updateChartData() {
    const personalValues = [this.claimSummary.New, this.claimSummary.Open, this.claimSummary.Resolved, this.claimSummary.Closed];
    const overallValues = [this.overallClaimSummary.New, this.overallClaimSummary.Open, this.overallClaimSummary.Resolved, this.overallClaimSummary.Closed];

    this.claimChartData = {
      labels: ['New', 'Open', 'Resolved', 'Closed'],
      datasets: [{ data: personalValues, backgroundColor: ['#1976d2', '#f57c00', '#388e3c', '#616161'], borderColor: 'transparent' }],
    };
    this.overallChartData = {
      labels: ['New', 'Open', 'Resolved', 'Closed'],
      datasets: [{ data: overallValues, backgroundColor: ['#1976d2', '#f57c00', '#388e3c', '#616161'], borderColor: 'transparent' }],
    };
  }

  jumpCreateClaim() {
    if (!this.isBlocked) {
      this.dialog.open(ClaimNewComponent, {
        width: '50vw',
        position: { right: '0', top: '60px' },
      });
    }
  }

  jumpCreateCompany() {
    this.companyService.skipListFlag = true;
    if(!this.isBlocked){
      this.router.navigate([routing.CompanyRegistration]);
    }
    
  }

  jumpCreateVessel() { 
    this.vesselService.skipListFlag = true;
    if(!this.isBlocked){ 
      this.router.navigate([routing.VesselRegistration]);}
   
  }

  jumpCreateUser() {
    this.userService.skipListFlag = true;
    if(!this.isBlocked){ 
      this.router.navigate([routing.UserRegistration]);}
   
  }

  goCompanyPage() {
    if(!this.isCompanyPage){
      this.router.navigate([routing.CompanyList]);
    }
  }

  goVesselPage() {
    if(!this.isVesselPage){
      this.router.navigate([routing.Vessel]);
    }
  }

  goUserPage() {
    this.router.navigate([routing.UserList]);
  }
  
  goTenantPage() {
    this.router.navigate([routing.TenantList]);
  }

  goMeetingsPage() {
    this.router.navigate([routing.Calendar]);
  }

  goClaimCenterPage() {
    this.router.navigate([routing.ClaimCenter]);
  }

  goInquiryCenterPage() {
    this.router.navigate([routing.InquiryCenter]);
  }

  logout() {
    this.authService.logoutRedirect({
      postLogoutRedirectUri: environment.msalConfig.auth.redirectUri
    });
  }

  get isAdmin() {
    return this.auth.isAdmin || this.auth.isGlobalAdmin || this.auth.isUser;
  }

  getIsCompanyPage() {
    this.companyService.isCompanyPageChanges
    .pipe(takeUntil(this.onDestroy$))
    .subscribe({
      next: (value) => {
        this.isCompanyPage = value}
    })
  }

  getIsVesselPage() {
    this.vesselService.isVesselPageChanges
    .pipe(takeUntil(this.onDestroy$))
    .subscribe({
      next: (value) => {
        this.isVesselPage = value;
      }
    })
  }

  onActivate(elementRef: any) {
    elementRef?.dataChange?.subscribe((event:any) => {
      this.getAllCount();
    })
  }

}
